<bspk-form-field [controlId]="controlId()"
                 [errorMessage]="errorMessage()"
                 [helperText]="helperText()"
                 [label]="label()">
  <div data-chip-list (click)="input.focus()">
    @for (value of values(); track value) {
      <bspk-chip role="option" [disabled]="disabled()" [label]="value" [removable]="!readonly() && !disabled()" (removed)="remove($index)" />
    }
    <input #input
           [disabled]="disabled()"
           [id]="controlId()"
           [readonly]="readonly()"
           [value]="inputValue()"
           (blur)="blur.emit($event)"
           (input)="onInput($event)"
           (keydown.enter)="addValue()">
  </div>
</bspk-form-field>
